import React, { useContext, useEffect, useRef, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import moment from "moment";
import Select from "react-select";
import { useApiCall } from "../../../../../component/custom-hooks/api-call";
import { GlobalContext } from "../../../../../context/Context";
import {
  FeildError,
  FeildWraper,
  FormArea,
  FormLabel,
} from "../../../../../component/form/form-layout";

const AddActivityModal = ({
  onSubmit = () => {},
  onClose = () => {},
  onError = () => {},
  PackageList = [],
  CustomerData = {},
  UsersList = [],
  entityData = [],
  onSearchEntity,
  id,
  entitytype,
  entityname,
  Style,
}) => {
  let { state } = useContext(GlobalContext);

  const userOptions = UsersList?.map((agents) => ({
    value: agents.userid,
    label: agents.name,
  }));

  const [showSuggestions, setShowSuggestions] = useState(false);

  const apiCall = useApiCall();

  console.log("CustomerData", CustomerData);

  useEffect(() => {
    if (CustomerData && Object.keys(CustomerData).length > 0) {
      // Edit mode
      const selectedEntity = CustomerData.entity_id
        ? {
            value: CustomerData.entity_id,
            label: `${CustomerData.entity?.name} (${CustomerData.entity_type})`,
            type: CustomerData.entity_type,
          }
        : null;

      formik.setValues({
        type: CustomerData.type || "",
        due_date: CustomerData.due_date
          ? moment(CustomerData.due_date).format("YYYY-MM-DD")
          : "",
        due_time: CustomerData.due_time
          ? moment(CustomerData.due_time, ["HH:mm:ss", "HH:mm"]).format("HH:mm")
          : "",
        priority: CustomerData.priority || "",
        status: CustomerData.status || "",
        entity: selectedEntity,
        assigned: CustomerData?.assignee?.userid || "",
        notes: CustomerData.note || "",
      });
    } else {
      // Add mode

      if (id && entitytype) {
        const selectedEntity = {
          value: id,
          label: `${entityname} (${entitytype})`,
          type: entitytype,
        };

        formik.setFieldValue("entity", selectedEntity);
      } else {
        formik.resetForm();
      }
    }
  }, [CustomerData]);

  const validationSchema = yup.object({
    type: yup.string().required("Type is required"),
    due_date: yup.string().required("Due date is required"),
    due_time: yup.string().required("Due time is required"),
    priority: yup.string().required("Priority is required"),
    status: yup.string().required("Status is required"),
    entity: yup.mixed().required("Entity is required"),
    assigned: yup.string().required("Assigned user is required"),
    notes: yup.string().required("Notes are required"),
  });

  const formik = useFormik({
    initialValues: {
      type: "",
      due_date: "",
      due_time: "",
      priority: "",
      status: "",
      entity: null,
      assigned: "",
      notes: "",
    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      const isEdit = !!CustomerData?.id;

      const entity_id = CustomerData?.entity_id;
      const entity_type = CustomerData?.entity_type;

      const userId = state?.user?.userid;

      const data = {
        entity_id: values.entity?.value || "",
        entity_type: values.entity?.type || "",
        assigned_to: formik.values.assigned || "",
        type: formik.values.type,
        subject: formik.values.subject || "Activity",
        note: formik.values.notes,
        due_date: formik.values.due_date,
        due_time: formik.values.due_time,
        priority: formik.values.priority,
        status: formik.values.status,
      };

      try {
        const apiRes = await apiCall({
          method: "post",
          url: isEdit
            ? `activities/update-activity/${CustomerData?.id}`
            : "activities/add-activity",
          data,
        });

        formik.resetForm();
        onSubmit(apiRes?.message || "Request Submitted");
        onClose();
      } catch (error) {
        console.log("Error", error);
        onError(
          error?.response?.data?.respMsg ||
            error?.response?.data?.message ||
            "Something went wrong"
        );
      }
    },
  });

  const suggestionList = [
    "Call",
    "Meeting",
    "Email",
    "Follow-up",
    "Demo",
    "Chat",
    "Consultation",
    "Presentation",
  ];

  return (
    <div style={{ height: "100%", overflow: "auto" }}>
      <form onSubmit={formik.handleSubmit} className={Style.modal_main}>
        <div className={Style.modal_body}>
          <FormArea>
            {/* type */}

            <FeildWraper width="100%">
              <FormLabel required>Type</FormLabel>
              <div className="relative">
                <input
                  type="text"
                  name="type"
                  value={formik.values.type}
                  onChange={(e) => {
                    formik.setFieldValue("type", e.target.value);
                    setShowSuggestions(true);
                  }}
                  onFocus={() => setShowSuggestions(true)}
                  onBlur={() =>
                    setTimeout(() => setShowSuggestions(false), 200)
                  } // thoda delay taake click register ho
                  placeholder="Type activity (e.g. Call, Meeting...)"
                  autoComplete="off"
                />

                {/* suggestion dropdown */}
                {showSuggestions &&
                  formik.values.type &&
                  suggestionList.filter((item) =>
                    item
                      .toLowerCase()
                      .includes(formik.values.type.toLowerCase())
                  ).length > 0 && (
                    <ul
                      className="absolute   left-0 right-0 bg-white border border-gray-200 rounded-md mt-1 max-h-40   overflow-y-auto shadow-lg z-[999]"
                      style={{ listStyle: "none", padding: 0, margin: 0 }}
                    >
                      {suggestionList
                        .filter((item) =>
                          item
                            .toLowerCase()
                            .includes(formik.values.type.toLowerCase())
                        )
                        .map((suggestion, i) => (
                          <li
                            key={i}
                            onClick={() => {
                              formik.setFieldValue("type", suggestion);
                              setShowSuggestions(false);
                            }}
                            className="px-3 py-2 hover:bg-blue-100 cursor-pointer text-sm"
                          >
                            {suggestion}
                          </li>
                        ))}
                    </ul>
                  )}
              </div>

              {formik.touched.type && formik.errors.type && (
                <FeildError>{formik.errors.type}</FeildError>
              )}
            </FeildWraper>

            {/* Due Date */}
            <FeildWraper>
              <FormLabel required>Due Date</FormLabel>
              <input
                type="date"
                name="due_date"
                min={new Date().toISOString().split("T")[0]}
                value={formik.values.due_date}
                onChange={formik.handleChange}
                placeholder="Due Date"
              />
              {formik.touched.due_date && formik.errors.due_date && (
                <FeildError>{formik.errors.due_date}</FeildError>
              )}
            </FeildWraper>

            {/* Due Time */}

            <FeildWraper>
              <FormLabel required>Due Time</FormLabel>
              <input
                type="time"
                name="due_time"
                value={formik.values.due_time}
                onChange={formik.handleChange}
                placeholder="Due Time"
              />
              {formik.touched.due_time && formik.errors.due_time && (
                <FeildError>{formik.errors.due_time}</FeildError>
              )}
            </FeildWraper>

            {/* Priority */}

            <FeildWraper>
              <FormLabel required>Priority</FormLabel>
              <select
                name="priority"
                value={formik.values.priority}
                onChange={formik.handleChange}
              >
                <option value="">-- Select Priority --</option>
                <option value="low">Low</option>
                <option value="medium">Medium</option>
                <option value="high">High</option>
              </select>
              {formik.touched.priority && formik.errors.priority && (
                <FeildError>{formik.errors.priority}</FeildError>
              )}
            </FeildWraper>

            {/* Status */}
            <FeildWraper>
              <FormLabel required>Status</FormLabel>
              <select
                name="status"
                value={formik.values.status}
                onChange={formik.handleChange}
              >
                <option value="" disabled>
                  -- Select Status --
                </option>
                <option value="pending">Pending</option>
                <option value="rejected">Rejected</option>
                <option value="completed">Completed</option>
              </select>
              {formik.touched.status && formik.errors.status && (
                <FeildError>{formik.errors.status}</FeildError>
              )}
            </FeildWraper>

            {/*  project */}
            <FeildWraper>
              <FormLabel required>Lead Deal or Project</FormLabel>
              <Select
                name="entity"
                className="text-sm"
                classNamePrefix="react-select"
                value={formik.values.entity || null}
                options={entityData.map((e) => ({
                  label: `${e.name} (${e.type})`,
                  value: e.id,
                  type: e.type,
                }))}
                components={{
                  IndicatorSeparator: () => null,
                }}
                onChange={(opt) => {
                  formik.setFieldValue("entity", opt || null);
                }}
                styles={{
                  control: (base, state) => ({
                    ...base,
                    borderColor: state.isFocused ? "#e5e7eb" : "#e5e7eb",
                    boxShadow: state.isFocused ? "0 0 0 1px #none" : "none",
                    "&:hover": { borderColor: "#none" },
                    borderRadius: "0.5rem",
                    minHeight: "40px",
                    fontSize: "0.875rem",
                  }),
                  menu: (base) => ({
                    ...base,
                    zIndex: 9999,
                    borderRadius: "0.5rem",
                    padding: "0.25rem 0",
                  }),
                  option: (base, { isFocused, isSelected }) => ({
                    ...base,
                    backgroundColor: isSelected
                      ? "#3b82f6"
                      : isFocused
                      ? "#eff6ff"
                      : "white",
                    color: isSelected ? "white" : "#111827",
                    cursor: "pointer",
                    fontSize: "0.875rem",
                  }),
                  placeholder: (base) => ({
                    ...base,
                    color: "#9ca3af",
                  }),
                }}
                placeholder="Search here"
                isClearable
              />
              {formik.touched.entity && formik.errors.entity && (
                <FeildError>{formik.errors.entity}</FeildError>
              )}
            </FeildWraper>

            {/*  Assigned */}
            <FeildWraper>
              <FormLabel required>Assigned</FormLabel>
              <Select
                name="assigned"
                className="text-sm"
                classNamePrefix="react-select"
                options={userOptions}
                components={{
                  IndicatorSeparator: () => null,
                }}
                // ✅ Only depend on formik value
                value={
                  userOptions.find(
                    (option) => option.value === formik.values.assigned
                  ) || null
                }
                onChange={(selectedOption) => {
                  // ✅ Set only ID
                  formik.setFieldValue("assigned", selectedOption?.value || "");
                }}
                placeholder="Assigned..."
                isClearable
                menuPlacement="auto"
                styles={{
                  control: (base, state) => ({
                    ...base,
                    borderColor: state.isFocused ? "#e5e7eb" : "#e5e7eb",
                    boxShadow: state.isFocused ? "0 0 0 1px #none" : "none",
                    "&:hover": { borderColor: "#none" },
                    borderRadius: "0.5rem",
                    minHeight: "40px",
                    fontSize: "0.875rem",
                  }),
                  menu: (base) => ({
                    ...base,
                    zIndex: 9999,
                    borderRadius: "0.5rem",
                    padding: "0.25rem 0",
                  }),
                  option: (base, { isFocused, isSelected }) => ({
                    ...base,
                    backgroundColor: isSelected
                      ? "#3b82f6"
                      : isFocused
                      ? "#eff6ff"
                      : "white",
                    color: isSelected ? "white" : "#111827",
                    cursor: "pointer",
                    fontSize: "0.875rem",
                  }),
                  placeholder: (base) => ({
                    ...base,
                    color: "#9ca3af",
                  }),
                }}
              />
              {formik.touched.assigned && formik.errors.assigned && (
                <FeildError>{formik.errors.assigned}</FeildError>
              )}
            </FeildWraper>

            {/* notes */}
            <FeildWraper width="100%">
              <FormLabel>Notes</FormLabel>
              <textarea
                placeholder="write your notes here..."
                name="notes"
                value={formik.values.notes}
                onChange={formik.handleChange}
              ></textarea>
            </FeildWraper>
          </FormArea>
        </div>

        <div className={Style.modal_foot}>
          <button
            type="reset"
            className={`${Style.dcmb__cancel} opacity-0 pointer-events-none cursor-default`}
            onClick={onClose}
          >
            Discard
          </button>
          <button type="submit" className={`${Style.dcmb__submit}`}>
            {CustomerData?.id ? "Save Changes" : "Create Follow Ups"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddActivityModal;
